import { render } from "./EmployeeSkills.vue?vue&type=template&id=859a8c70&scoped=true"
import script from "./EmployeeSkills.vue?vue&type=script&lang=js"
export * from "./EmployeeSkills.vue?vue&type=script&lang=js"

import "./EmployeeSkills.vue?vue&type=style&index=0&id=859a8c70&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-859a8c70"]])

export default __exports__